var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as R from 'ramda';
import { XbpmFormType } from '../../models/xbpm.enums';
import { isNotNil } from '../utils/_.utils';
//
export var mapResponse = R.path(['data']);
export var mapFormResponse = R.pipe(mapResponse, function (data) {
    return !data
        ? null
        : __assign(__assign(__assign({}, R.pick(['applicationGroup', 'applicationCode', 'applicationVersion', 'processInstanceId', 'processDefinitionKey'], data)), { taskDefinitionKey: data.taskDefinitionKey || data.code, taskDefinitionType: data.type, taskDefinitionName: data.name, freeFormCode: data.type === XbpmFormType.FREE ? data.code : null }), data.block);
});
// map url path
var pathTaskParamsOrder = [
    'processInstanceId',
    'taskDefinitionKey',
    'blockCode',
    'buttonCode',
    'targetBlockCode',
    'modalFormCode',
];
var appPathParams = ['applicationGroup', 'applicationCode', 'applicationVersion'];
var appPathPartParams = ['freeFormCode', 'blockCode', 'buttonCode', 'targetBlockCode'];
var pathAppParamsOrder = __spreadArrays(appPathParams, appPathPartParams);
var mapPathParams = function (order) {
    return R.pipe(R.toPairs, R.sortBy(R.pipe(function (_a) {
        var p = _a[0];
        return order.indexOf(p);
    }, function (p) { return (p === -1 ? Infinity : p); })), R.map(R.path([1])), R.filter(isNotNil));
};
var mapTaskPathParams = mapPathParams(pathTaskParamsOrder);
var mapAppPathParams = mapPathParams(pathAppParamsOrder);
export var getTaskFormFullPath = function (url, pathParams) {
    return __spreadArrays([url], (pathParams ? mapTaskPathParams(pathParams) : [])).join('/');
};
export var getAppPath = function (url, pathParams) {
    return __spreadArrays([url], (pathParams ? mapAppPathParams(R.pick(appPathParams, pathParams)) : [])).join('/');
};
export var getFreeFormPathPart = function (url, pathParams) {
    return __spreadArrays([url], (pathParams ? mapAppPathParams(R.pick(appPathPartParams, pathParams)) : [])).join('/');
};
//# sourceMappingURL=api.utils.js.map